import { BaseService } from './BaseService';
import { ConfigApi } from '../config/Constantes';

class DispositivoService extends BaseService {
  constructor() {
    super(`${ConfigApi.dispositivoURL}`);
  }

  async sincronizaChave(body) {
    delete body.id;
    this.setLoading(true);
    try {
      const response = await this.api.post(`${this.url}/sincroniza`, body);
      return response.data;
    } finally {
      this.setLoading(false);
    }
  }

  getFilter() {
    return new Filter();
  }
}

class Filter {
  constructor() {
    this.numeroContrato = '';
    this.limit = 11;
    this.page = 0;
  }
}
export default new DispositivoService();
